import { Cancel, CheckCircle, ContentCopy } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useState } from 'react';

type CopyIndicator = { type: 'success' | 'default' | 'error'; icon: React.ReactElement };
const copyDefault: CopyIndicator = { type: 'default', icon: <ContentCopy fontSize="small" color="primary" /> };
const copySuccess: CopyIndicator = { type: 'success', icon: <CheckCircle fontSize="small" color="success" /> };
const copyError: CopyIndicator = { type: 'error', icon: <Cancel fontSize="small" color="error" /> };

export const CopyToClipboard = ({ value }: { readonly value: string }) => {
  const [copyIndicator, setCopyIndicator] = useState(copyDefault);

  return (
    <IconButton
      size="small"
      onClick={async () => {
        try {
          await window.navigator.clipboard.writeText(value);
          if (copyIndicator.type !== 'success') {
            setCopyIndicator(copySuccess);
            setTimeout(() => setCopyIndicator(copyDefault), 2_000);
          }
        } catch {
          if (copyIndicator.type !== 'error') {
            setCopyIndicator(copyError);
            setTimeout(() => setCopyIndicator(copyDefault), 2_000);
          }
        }
      }}
    >
      {copyIndicator.icon}
    </IconButton>
  );
};
